import React, {useState} from 'react';
import {RR_STATUS} from "../../constants/RRConstants";
import {useTranslation} from "react-i18next";
import {useSnackbar} from "notistack";
import Loader from "../core/Loader";
import {Container, FormControl} from "@material-ui/core";
import {getActiveTermsAndConditions} from "../../api/TermsAndConditionsEndpoints";
import CloseBottomBar from "../core/CloseBottomBar";
import {HOME_OVERVIEW_PAGE_PATH} from "../../layouts/navigation/Navigator";
import {useNavigate} from "react-router-dom";
import Select from "@material-ui/core/Select";

const DEFAULT_LANGUAGE = "English";

interface ITermsAndConditions {
    status: string
    language: string
    text: string
}

const LanguageSelectionCombobox: React.FC<{ languages: string[], onChange: (lang: any) => void }> = ({languages, onChange}) => {
    return <FormControl size="small" variant="outlined">
        <Select native onChange={event => onChange(event.target.value)} defaultValue={DEFAULT_LANGUAGE}>
            {languages.map(language => <option key={language} value={language}>{language}</option>)}
        </Select>
    </FormControl>
};


const TermsAndConditionsPageComponents = () => {
    const {t} = useTranslation();
    const {enqueueSnackbar} = useSnackbar();
    const navigate = useNavigate();

    const [currentLanguage, setCurrentLanguage] = useState<string>(DEFAULT_LANGUAGE);
    const [termsAndConditions, setTermsAndConditions] = useState<ITermsAndConditions[]>([]);

    const getCurrentLanguageText = (): string => {
        return termsAndConditions.filter(lang => lang.language === currentLanguage)[0].text;
    };

    React.useEffect(() => {
        getActiveTermsAndConditions().then(({data}) => {
            const {status, response} = data;

            if (status !== RR_STATUS.OK) {
                enqueueSnackbar(t("core.server-error"), {
                    variant: "error",
                    preventDuplicate: false
                });
            } else {
                setTermsAndConditions(response.contents);
            }
        })
    }, [enqueueSnackbar, t, setTermsAndConditions]);


    if (!termsAndConditions.length) {
        return <Loader/>
    }

    return (
        <Container>

            <LanguageSelectionCombobox languages={termsAndConditions?.map(terms => terms.language)}
                                       onChange={setCurrentLanguage}/>

            <div dangerouslySetInnerHTML={{__html: getCurrentLanguageText()}}/>

            <CloseBottomBar executeClose={() => navigate(HOME_OVERVIEW_PAGE_PATH)}/>
        </Container>
    );
};

export default TermsAndConditionsPageComponents;